export const LATE_EARLY_APPLICATION_TYPE = {
  CHECK_IN: 0,
  CHECK_OUT: 1,
};
